import fetchHTTP from 'Utils/fetchHTTP';

const fetchEmailVerificationStatus = () => fetchHTTP('/v1/protected/email_verification/verified', {
  method: 'GET',
});

export default fetchEmailVerificationStatus;
